import axios from 'axios';

export default axios.create({
  baseURL: 'https://5hatki-bam.com/api/'
});
